import { FC } from 'react'

import { MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import { getChannelUtilizationContent } from '../../utils/planContentUtils'
import CustomizableSection from './CustomizableSection'

export interface ChannelUtilizationProps {
    campaigns: MasterCampaignPlanCampaignBuilder[]
    section: MasterCampaignPlanCustomSection | null | undefined
}

const ChannelUtilization: FC<ChannelUtilizationProps> = ({ campaigns, section }) => {
    const channelContent = getChannelUtilizationContent(campaigns)

    if (!channelContent) {
        return null
    }

    return <CustomizableSection section={section} defaultTitle='Channel Utilization' defaultContent={channelContent} defaultShowTitle={true} separator='spacer' />
}

export default ChannelUtilization
